import { render, staticRenderFns } from "./VInvoicesResponsible.vue?vue&type=template&id=1304e18b&"
import script from "./VInvoicesResponsible.vue?vue&type=script&lang=js&"
export * from "./VInvoicesResponsible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports